import { IFormAccessJBP } from 'legacy/lut/classes/models/partner360/IFormAccessJBP'
import { appGetState } from 'legacy/lut/store'

import { IPaging, IPagingFromTo } from 'core-components/types'
import { IDataProviderFilter, IFilter } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export class PartnerDetailsApi {
  public static fetchTopPartnersDetails = async (
    filter: IDataProviderFilter,
    paging: IPaging | IPagingFromTo
  ) => {
    const yearFilter: IFilter | undefined = filter.filters.find(
      (el) => (el as IFilter).field === 'FYear'
    ) as IFilter | undefined
    const statusFilter: IFilter | undefined = filter.filters.find(
      (el) => (el as IFilter).field === 'RadStatus'
    ) as IFilter | undefined
    if (yearFilter && yearFilter.value && statusFilter && statusFilter.value) {
      const url = proxy(`/webservice/590/sp/v3/spJBPDaasTopPartnersDetails/call`)
      const payload = {
        'p.FYear': yearFilter.value,
        'p.RadStatus': statusFilter.value,
        'p.NumOfPartners': paging['pageSize'] || paging['to'] || 0,
      }

      const { app } = appGetState()
      const [accessToken] = await getTokens(app.ownerId)

      const headers = new HttpHeaders()
      if (accessToken) {
        headers.add('Authorization', `Bearer ${accessToken}`)
      }
      const response = await Rest.post({ url, payload, headers })
      const rows = (response && response['Rows']) || []
      return { Data: rows }
    }
    return { Data: [] }
  }

  public static fetchTopPartnersSummary = async (
    fyear: number,
    numOfPartners: number,
    status: string
  ) => {
    const url = proxy(`/webservice/590/sp/v3/spJBPDaasTopPartnersSummary/call`)
    const payload = {
      'p.FYear': fyear,
      'p.RadStatus': status,
      'p.NumOfPartners': numOfPartners,
    }

    const { app } = appGetState()
    const [accessToken] = await getTokens(app.ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    const response = await Rest.post({ url, payload, headers })
    const rows: IFormAccessJBP[] = (response && response['Rows']) || []
    return { Data: rows }
  }

  public static exportTopPartnersDetails = async (fyear: number, numOfPartners: number) => {
    const url = proxy(`/webservice/590/sp/v3/spJBPDaasTopPartnersDetails/call/export`)
    const payload = {
      'p.FYear': fyear,
      'p.NumOfPartners': numOfPartners,
    }

    const { app } = appGetState()
    const [accessToken] = await getTokens(app.ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    const response = await Rest.post({ url, payload, headers })
    return response
  }
}
